import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useSnackbar } from 'notistack';
import apiClient from '../../../../../api/apiClient';
import { usePreloaderStore } from '../../../../../stores';
import { Endpoints } from '../../../../../views/democracy/constants';
import { extractErrorMessage } from '../../../../../views/democracy/utils';
import Modal from '../../controls/Modal';
import LabeledInput from '../../controls/LabeledInput';

// Модалка первичного создания игры «Демократия» для смены.
export default function CreateDemocracyModal({ smenaId, onCreated, onClose }) {
    const { enqueueSnackbar } = useSnackbar();
    const { show, hide } = usePreloaderStore();
    const [title, setTitle] = useState('');
    const [description, setDescription] = useState('');

    const handleCreate = async () => {
        if (!title.trim()) {
            enqueueSnackbar('Заполните название', { variant: 'warning' });
            return;
        }
        show();
        try {
            await apiClient.post(
                Endpoints.democracies.create,
                { title: title.trim(), description: description.trim() || null },
                { params: smenaId ? { smenaId } : undefined }
            );
            onCreated();
            enqueueSnackbar('Игра «Демократия» создана', { variant: 'success' });
        } catch (error) {
            enqueueSnackbar(extractErrorMessage(error, 'Не удалось создать Democracy'), { variant: 'error' });
        } finally {
            hide();
        }
    };

    const footer = (
        <>
            <button type="button" className="btn btn-ghost" onClick={onClose}>Отмена</button>
            <button type="button" className="btn btn-primary" onClick={handleCreate}>Создать</button>
        </>
    );

    return (
        <Modal open title="Создать игру «Демократия»" onClose={onClose} size="sm" footer={footer}>
            <LabeledInput label="Название" value={title} onChange={(e) => setTitle(e.target.value)} />
            <div>
                <label className="ctl-label">Описание (необязательно)</label>
                <textarea className="textarea" value={description} onChange={(e) => setDescription(e.target.value)} />
            </div>
        </Modal>
    );
}

CreateDemocracyModal.propTypes = {
    smenaId: PropTypes.number,
    onCreated: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired
};

CreateDemocracyModal.defaultProps = { smenaId: undefined };
